import React,{useState} from "react";
import Draggable,{ DraggableEventHandler } from "react-draggable";
import { InputContainer } from "../style/LogStyles";
import { Icons } from "../icons/Icons";

interface Props {
  inputType: "improvement";
  isReadOnly: boolean;
  setIsImprovementVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

const DraggableInput: React.FC<Props> = ({
  inputType,
  setIsImprovementVisible,
  isReadOnly
}) => {
  const [dragged, setDragged] = useState(false);
  const onStop: DraggableEventHandler = (e, ui) => {
    setDragged(true);

    if (inputType === "improvement") {
      setIsImprovementVisible(true);
    }
  };

  return (
    <React.Fragment>
      {!dragged && (
        <Draggable onStop={onStop}>
          <InputContainer className={"draggable"} isReadOnly={isReadOnly}>
            <Icons
              value={inputType.toLowerCase()}
              height={35}
              width={35}
            />
          </InputContainer>
        </Draggable>
      )}
    </React.Fragment>
  );
};

export default DraggableInput;
